const initialState = {
  roles: [],
  rolesId: null,
};
export const accessReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_ACCESS': {
      return {
        ...state,
        roles: action.payload,
      };
    }

    case 'ADD_ROLE_ID': {
      return {
        ...state,
        rolesId: action.payload,
      };
    }

    case 'RESET_ACCESS': {
      return initialState;
    }

    default:
      return state;
  }
};

export default accessReducer;
